import React from 'react';
import { GlobalDialogBoxStyles } from './globalDialogBoxStyles';
import { Box, Dialog } from '@mui/material';


interface GlobalDialogBoxProps {
    children?: React.ReactNode;
    childrenWithTitle?: React.ReactNode;
    sizeType?: 'sm' | 'md' | 'lg';
    title?: string;
    innerChild?: React.ReactNode;
    actionsList?: {
        title: string;
        action: (() => void) | (() => Promise<void>);
        disabled?: boolean;
    }[];
    actionsChild?: React.ReactNode;
    flagNoPadding?: boolean;
    onClose?: () => void;
    isOpen?: boolean;
    flagVisible?: boolean;
}

const GlobalDialogBox: React.FC<GlobalDialogBoxProps> = (props) => {
    const {
        title,
        actionsList,
        onClose = () => {
        },
        children,
        isOpen,
        actionsChild,
        innerChild,
        childrenWithTitle,
        sizeType,
        flagNoPadding,
        flagVisible
    } = props;

    const {
        mainOuterDialogBoxContainer,
        normalBtn,
        mainTitleContainer,
        mainTitleText,
        textBoxContainer,
        buttonContainer,
        invisibleSpace,
    } = GlobalDialogBoxStyles({
        type: sizeType ?? "sm",
        flagNoPadding: flagNoPadding ?? false,
        flagVisible: flagVisible ?? true
    }).classes;


    return (
        <React.Fragment>
                <Dialog
                    open={isOpen !== undefined ? isOpen : true}
                    onClose={onClose}
                    className={mainOuterDialogBoxContainer}
                    disableEnforceFocus={true}
                    disableScrollLock
                >
                    {children !== undefined ?
                        children :
                        <>
                            <Box className={mainTitleContainer}>
                                <Box component={'span'}>
                                    {"Logo Image"}
                                </Box>
                                <Box component={'h3'} className={mainTitleText} >
                                    {title}
                                </Box>
                            </Box>

                            {childrenWithTitle !== undefined && childrenWithTitle}

                            {innerChild && <Box className={textBoxContainer}>
                                {innerChild}
                            </Box>}

                            {(actionsChild !== undefined || actionsList !== undefined) && <Box className={invisibleSpace}>
                            </Box>}
                            {
                                actionsChild !== undefined ? (
                                    actionsChild
                                ) : (
                                    actionsList !== undefined && actionsList.length > 0 && (
                                        <Box className={buttonContainer}>
                                            {actionsList.map((action, index) => (
                                                <button
                                                    type={"button"}
                                                    className={normalBtn}
                                                    disabled={action.disabled ?? false}
                                                    key={index}
                                                    onClick={() => {
                                                        action.action();
                                                        onClose();
                                                    }}
                                                >
                                                    {action.title}
                                                </button>
                                            ))}
                                        </Box>
                                    )
                                )
                            }
                        </>
                    }
                </Dialog>
        </React.Fragment >
    );
};

export default GlobalDialogBox;